import { VehiclePage } from '@/pages/vehicle/vehicle-page';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_protected/vehicles/$id')({
  component: VehiclePage,
});
